import loadImage from './loadImage.js';
import preloadImages from './preloadImages.js';
export default {
  loadImage,
  preloadImages
};


//////////////////
// WEBPACK FOOTER
// /Users/abonnal/Dev/jean-louis-david.lan/web/app/themes/jld/node_modules/swiper/core/images/index.js
// module id = 586
// module chunks = 0